import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import uuidv4 from "uuid/v4";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "material-ui/Dialog";
import Button from "material-ui/Button";

import DragNDropCalendar from "./DragNDropCalendar";
import PlanningListDialog from "./PlanningListDialog";

import Loading from "../utils/loading/Loading";
import Retry from "../utils/retry/Retry";
import {
  getPlanningsRequest,
  getPlanningsDone,
  addPlanningRequest,
  updatePlanningRequest,
  deletePlanningRequest,
  getSubcriptionStatusRequest,
} from "./actions";

import { getPlaylistsRequest } from "../playlists/actions";

import { checkPlanningsOverlap } from "./planningUtils";

import "../../styles/third-party/react-big-calendar.css";
import styles from "./Planning.scss";

class Plannings extends React.Component {
  static propTypes = {
    playlists: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      playlists: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired,
          id: PropTypes.string.isRequired,
        })
      ),
    }).isRequired,
    plannings: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      plannings: PropTypes.arrayOf(PropTypes.any),
    }).isRequired,
    login: PropTypes.shape({
      authData: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    getPlaylistsRequest: PropTypes.func.isRequired,
    getPlanningsRequest: PropTypes.func.isRequired,
    getPlanningsDone: PropTypes.func.isRequired,
    addPlanningRequest: PropTypes.func.isRequired,
    updatePlanningRequest: PropTypes.func.isRequired,
    deletePlanningRequest: PropTypes.func.isRequired,
    getSubcriptionStatusRequest: PropTypes.func.isRequired,
  };

  state = {
    action: undefined,
    planning: undefined,
  };

  componentDidMount() {
    if (document.getElementById("root").getElementsByTagName("section")[0]) {
      document
        .getElementById("root")
        .getElementsByTagName("section")[0].hidden = false;
    }
    this.loadData();
    // this.getUser();
  }

  componentWillUnmount() {
    this.props.getPlanningsDone();
  }
  // getUser = () => {
  //   const { id: accessToken, userId } = this.props.login.authData;
  //   const { user }=this.props
  //   this.props.getSubcriptionStatusRequest({ accessToken, userId, user });
  // }
  getPlaylists = () => {
    const { id: accessToken, userId } = this.props.login.authData;

    this.props.getPlaylistsRequest({ accessToken, userId });
  };

  getPlannings = () => {
    const { id: accessToken, userId } = this.props.login.authData;
    this.props.getPlanningsRequest({ accessToken, userId });
  };

  loadData = () => {
    if (typeof this.props.playlists.playlists === "undefined") {
      this.getPlaylists();
    }

    if (typeof this.props.plannings.plannings === "undefined") {
      this.getPlannings();
    }
  };

  handleRetry = () => {
    this.loadData();
  };

  handleSelectSlot = (slotInfo) => {
    if (checkPlanningsOverlap(this.props.plannings.plannings, slotInfo)) {
      this.setState({
        action: "create",
        planning: {
          start: slotInfo.start,
          end: slotInfo.end,
        },
      });
    }
  };

  handleConfirmAction = (playlistId) => {
    const { title } = this.props.playlists.playlists.find(
      ({ id }) => id === playlistId
    );
    const { id: accessToken, userId } = this.props.login.authData;
    const { planning } = this.state;

    if (planning.id) {
      this.props.updatePlanningRequest({
        planning: {
          ...planning,
          title,
          playlistId,
        },
        accessToken,
        userId,
      });

      return;
    }

    this.props.addPlanningRequest({
      planning: {
        ...planning,
        tempId: uuidv4(),
        title,
        playlistId,
      },
      accessToken,
      userId,
    });
  };

  handleSelectEvent = (event) => {
    if (!event.requesting) {
      this.setState({
        action: "update",
        planning: event,
      });
    }
  };

  handleEventDrop = ({ event, start, end }) => {
    this.updatePlanningDates(event, start, end);
  };

  handleEventResize = (_, { event, start, end }) => {
    this.updatePlanningDates(event, start, end);
  };

  updatePlanningDates = (event, start, end) => {
    if (
      end.getHours() >= 21 ||
      (end.getHours() === 20 && end.getMinutes() === 59)
    ) {
      return;
    }
    let fixedEnd = end;
    if (fixedEnd.getMinutes() === 59) {
      fixedEnd = new Date(
        fixedEnd.getFullYear(),
        fixedEnd.getMonth(),
        fixedEnd.getDate(),
        fixedEnd.getHours() + 1,
        0
      );
    }

    if (
      start.getDate() + 1 === fixedEnd.getDate() &&
      fixedEnd.getHours() === 0
    ) {
      fixedEnd = new Date(
        fixedEnd.getFullYear(),
        fixedEnd.getMonth(),
        fixedEnd.getDate() - 1,
        // 23,
        19,
        59
      );
    }
    if (
      !event.requesting &&
      checkPlanningsOverlap(
        this.props.plannings.plannings,
        { start, end: fixedEnd },
        event
      )
    ) {
      const { id: accessToken, userId } = this.props.login.authData;

      const data = {
        planning: {
          ...event,
          start,
          end: fixedEnd,
        },
        accessToken,
        userId,
      };

      if (event.id) {
        this.props.updatePlanningRequest(data);

        return;
      }

      this.props.addPlanningRequest(data);
    }
  };

  handleSyncFailed = (event) => {
    this.updatePlanningDates(event, event.start, event.end);
  };

  handleDeletePlanning = (event) => {
    if (!event.requesting) {
      this.setState({
        action: "delete",
        planning: event,
      });
    }
  };

  handleConfirmDeletePlanning = () => {
    const { id: accessToken, userId } = this.props.login.authData;
    this.props.deletePlanningRequest({
      planning: this.state.planning,
      accessToken,
      userId,
    });

    this.handleClose();
  };

  handleClose = () => {
    this.setState({
      action: undefined,
      planning: undefined,
    });
  };

  handleTouchMove = () => {
    /*
    return;
    var y = e.nativeEvent.touches[e.nativeEvent.touches.length - 1].clientY
    var container = document.getElementsByClassName("rbc-time-content")[0]
    console.log(y)
    if(y > 400 && !this.scrollAdjustDisabled){
      this.scrollAdjustDisabled = true
      setTimeout(()=>{
        this.scrollAdjustDisabled = false
      }, 500)
      container.scrollTop = container.scrollTop + 200
    }
    */
  };

  handleTouchStart = () => {
    document.body.style.overflow = "hidden";
  };

  handleTouchEnd = () => {
    document.body.style.overflow = "auto";
  };

  render() {
    const {
      playlists: {
        requesting: getPlaylistsRequesting,
        successful: getPlaylistsSuccessful,
        error: getPlaylistsError,
        playlists,
      },
      plannings: {
        requesting: getPlanningsRequesting,
        successful: getPlanningsSuccessful,
        error: getPlanningsError,
        plannings,
      },
    } = this.props;

    const { action, planning } = this.state;

    if (getPlaylistsRequesting || getPlanningsRequesting) {
      return <Loading size={80} />;
    }

    if (getPlaylistsError || getPlanningsError) {
      return <Retry message={getPlaylistsError} onRetry={this.handleRetry} />;
    }

    const events =
      this.state.planning && !this.state.planning.id
        ? [...plannings, this.state.planning]
        : plannings;

    if (getPlaylistsSuccessful && getPlanningsSuccessful) {
      return (
        <div
          className={styles.container}
          onTouchStart={this.handleTouchStart}
          onTouchMove={this.handleTouchMove}
          onTouchEnd={this.handleTouchEnd}
        >
          <DragNDropCalendar
            events={events}
            handleSelectSlot={this.handleSelectSlot}
            handleSelectEvent={this.handleSelectEvent}
            handleEventDrop={this.handleEventDrop}
            handleEventResize={this.handleEventResize}
            handleSyncFailed={this.handleSyncFailed}
            handleDeletePlanning={this.handleDeletePlanning}
          />
          <PlanningListDialog
            open={action === "create" || action === "update"}
            handleClose={this.handleClose}
            handleConfirmAction={this.handleConfirmAction}
            value={planning ? planning.playlistId : undefined}
            options={playlists}
          />
          <Dialog
            open={action === "delete"}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Supprimer le planning?
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                La suppression de ce planning est définitive.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Annuler
              </Button>
              <Button
                onClick={this.handleConfirmDeletePlanning}
                color="primary"
                autoFocus
              >
                Supprimer
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = (state) => ({
  playlists: state.playlists,
  plannings: state.plannings,
  login: state.login,
});

export default connect(mapStateToProps, {
  getPlaylistsRequest,
  getPlanningsRequest,
  getPlanningsDone,
  addPlanningRequest,
  updatePlanningRequest,
  deletePlanningRequest,
  getSubcriptionStatusRequest,
})(Plannings);



// WEBPACK FOOTER //
// ./src/pages/plannings/Plannings.jsx